import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import React, { useState, useEffect } from "react";
import MarkdownRenderer from "../../MarkdownRenderer";
import { convertMdxToMd } from "../../../lib/convertMdx";
import geoOverviewOneFile from "../../../assets/markDownFiles/geosafe/geosafe.md";

const GeoOverviewOne = () => {
  const [content, setContent] = useState("");
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    if (
      typeof geoOverviewOneFile === "string" &&
      geoOverviewOneFile.startsWith("/static")
    ) {
      fetch(geoOverviewOneFile)
        .then((res) => res.text())
        .then((raw) => setContent(convertMdxToMd(raw)));
    } else {
      setContent(convertMdxToMd(geoOverviewOneFile));
    }
  }, []);

  return (
    <Box sx={{ padding: "0" }}>
      <Typography
        sx={{
          color: "#e54f9c",
          fontWeight: "900",
          fontSize: "0.8rem",
          marginBottom: "0.35rem",
          marginLeft: isDesktop ? "0" : "5%",
        }}
      >
        ACT Geosafe
      </Typography>
      {content ? <MarkdownRenderer content={content} /> : <p>Loading...</p>}
    </Box>
  );
};

export default GeoOverviewOne;
